import { AuthServiceApi } from 'my-recruiter-auth-ts-if'
import { authConfig } from './api-config'

export const authServiceApi = new AuthServiceApi(authConfig)
